module.exports = __webpack_public_path__ + "static/media/accountSelector.1f4ac302.png";